import React, { Component } from 'react';

import FrameComponents from "../FrameComponents"; 

import "./index.css";

class dashboard extends Component {
  // 进入组件调用
  componentDidMount() {
    // 设置页面标题
    document.title = 'DropshipMan-custom-packaging';
  }

  render() {
   
    return (
      
      <div>
        <FrameComponents name="custom_packaging" /> 
      </div>
    );
    
  }
}

export default dashboard;
